import chapterPNG from '@/assets/img/chapter.png'
import sectionPNG from '@/assets/img/section.png'
import videoBluePNG from '@/assets/img/video_blue.png'
import videoPNG from '@/assets/img/video_icon.png'
import videoGrayPNG from '@/assets/img/video-play.png'
import paperPNG from '@/assets/img/paper_icon.png'
import paperBlue from '@/assets/img/paper_blue.png'
import paperGray from '@/assets/img/paper_gray.png'
import filePNG from '@/assets/img/file_icon.png'
import fileBluePNG from '@/assets/img/file_icon_blue.png'

// 缓存登录用户信息
export const SZPX = 'szpx'

/**
 * 本地缓存Key
*/

// 缓存登录用户信息
export const USER_INFO = 'userInfo'

/**
 * 页面布局key
 */

export const LAYOUT_DEFAULT = 'Default'
export const LAYOUT_AUTH = 'Auth'

/**
 * 支付类型key
 */
export const PAY_TYPE = {
  WECHAT: 'NATIVE',
  ALIPAY: 'ZFB_WEB'
}

/**
 * 支付状态
 */
export const PAY_STATUS = {
  DEFAULT: '默认',
  UNPAY: '未支付',
  PAYING: '支付中',
  PAYERROR: '支付失败',
  PAYED: '已支付',
  REFUND: '已退款',
  INVALID: '已作废或支付超时',
  CLOSE: '交易关闭'
}

/**
 * 图标映射
*/
export const ICON_MAP = {
  CATALOG: chapterPNG,
  KNOWLEDGE: sectionPNG,
  VIDEO: videoPNG,
  VIDEO_BLUE: videoBluePNG,
  WEIKE: videoPNG,
  PAPER: paperGray,
  PAPER_GRAY: paperPNG,
  WEIKE_GRAY: videoGrayPNG,
  WEIKE_BLUE: videoBluePNG,
  PAPER_BLUE: paperBlue,
  FILE: filePNG,
  FILE_BLUE: fileBluePNG
}

// 课程中心code
export const COURSE_CENTER_CODE = 'SZPX001'

// 附件类型
export const ATTACHMENT_ICON = {
  PDF: 'iconPDF',
  BIMFACE: 'icongongchengwenjian',
  WORD: 'iconWord',
  EXCEL: 'iconExecl',
  OTHER: 'iconwenjian',
  PPT: 'iconPPT',
  IMAGE: 'icontu'
}
// 附件类型
export const ATTACHMENT_COLOR = {
  PDF: 'rgb(250, 106, 146)',
  BIMFACE: 'rgb(32, 230, 255)',
  WORD: 'rgb(52, 162, 255)',
  EXCEL: 'rgb(76, 155, 108)',
  OTHER: 'rgb(226, 194, 91)',
  PPT: 'rgb(241, 106, 75)',
  IMAGE: 'rgb(160, 147, 200)'
}
